'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_VISIBLE = exports.SELECTOR_HIDE_EDIT_FORM = exports.SELECTOR_TOGGLE_EDIT_FORM = exports.SELECTOR_DELETE_ADDRESS = exports.SELECTOR_HIDE_CREATE_FORM = exports.SELECTOR_TOGGLE_CREATE_FORM = exports.SELECTOR_EDIT_ADDRESS = exports.SELECTOR_CREATE_ADDRESS = exports.SELECTOR_ADDRESSES_TEMPLATE = exports.ATTR_INDEX = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _addresses = require('./../../components/addresses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATTR_INDEX = exports.ATTR_INDEX = 'data-index';

var SELECTOR_ADDRESSES_TEMPLATE = exports.SELECTOR_ADDRESSES_TEMPLATE = '[data-addresses-template]';
var SELECTOR_CREATE_ADDRESS = exports.SELECTOR_CREATE_ADDRESS = '[data-addresses-template-create]';
var SELECTOR_EDIT_ADDRESS = exports.SELECTOR_EDIT_ADDRESS = '[data-address-template-edit]';

var SELECTOR_TOGGLE_CREATE_FORM = exports.SELECTOR_TOGGLE_CREATE_FORM = '[data-address-create-toggle]';
var SELECTOR_HIDE_CREATE_FORM = exports.SELECTOR_HIDE_CREATE_FORM = '[data-address-create-hide]';
var SELECTOR_DELETE_ADDRESS = exports.SELECTOR_DELETE_ADDRESS = '[data-address-delete]';
var SELECTOR_TOGGLE_EDIT_FORM = exports.SELECTOR_TOGGLE_EDIT_FORM = '[data-address-edit-toggle]';
var SELECTOR_HIDE_EDIT_FORM = exports.SELECTOR_HIDE_EDIT_FORM = '[data-address-edit-hide]';

var CLASS_VISIBLE = exports.CLASS_VISIBLE = 'is-visible';

var AddressesTemplate = function () {
  function AddressesTemplate(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, AddressesTemplate);

    this.container = container;

    //Create address form wrapper
    this.createForms = [];
    this.editForms = [];

    (0, _jquery2.default)(SELECTOR_CREATE_ADDRESS).each(function (i, e) {
      var self = (0, _jquery2.default)(e);
      var form = new _addresses.CreateAddressForm(self);
      _this.createForms.push(form);
    });

    (0, _jquery2.default)(SELECTOR_EDIT_ADDRESS).each(function (i, e) {
      var self = (0, _jquery2.default)(e);
      var form = new _addresses.EditAddressForm(self);
      _this.editForms.push(form);
    });

    this.container.on('click', SELECTOR_TOGGLE_CREATE_FORM, function (e) {
      return _this.onToggleCreateForm(e);
    });
    this.container.on('click', SELECTOR_HIDE_CREATE_FORM, function (e) {
      return _this.onHideCreateForm(e);
    });
    this.container.on('click', SELECTOR_DELETE_ADDRESS, function (e) {
      return _this.onDeleteAddress(e);
    });
    this.container.on('click', SELECTOR_TOGGLE_EDIT_FORM, function (e) {
      return _this.onToggleEditForm(e);
    });
    this.container.on('click', SELECTOR_HIDE_EDIT_FORM, function (e) {
      return _this.onHideEditForm(e);
    });
  }

  (0, _createClass3.default)(AddressesTemplate, [{
    key: 'onToggleCreateForm',
    value: function onToggleCreateForm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.container.find(SELECTOR_CREATE_ADDRESS).toggleClass(CLASS_VISIBLE);
    }
  }, {
    key: 'onHideCreateForm',
    value: function onHideCreateForm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.container.find(SELECTOR_CREATE_ADDRESS).removeClass(CLASS_VISIBLE);
    }
  }, {
    key: 'onDeleteAddress',
    value: function onDeleteAddress(e) {
      var self = (0, _jquery2.default)(e.currentTarget);
      var id = self.attr('data-id');
      if (!id) return;

      if (confirm(window.Language.strings['customer.addresses.delete_confirm'])) {
        Shopify.postLink('/account/addresses/' + id, { parameters: { _method: 'delete' } });
      }
    }
  }, {
    key: 'onToggleEditForm',
    value: function onToggleEditForm(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = (0, _jquery2.default)(e.currentTarget);
      var id = self.attr(ATTR_INDEX);
      var form = this.container.find(SELECTOR_EDIT_ADDRESS + '[' + ATTR_INDEX + '="' + id + '"]');
      form.toggleClass(CLASS_VISIBLE);
    }
  }, {
    key: 'onHideEditForm',
    value: function onHideEditForm(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = (0, _jquery2.default)(e.currentTarget);
      self.closest(SELECTOR_EDIT_ADDRESS).removeClass(CLASS_VISIBLE);
    }
  }]);
  return AddressesTemplate;
}();

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(SELECTOR_ADDRESSES_TEMPLATE).each(function (i, e) {
    new AddressesTemplate((0, _jquery2.default)(e));
  });
});